import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget-placeholder',
  templateUrl: './widget-placeholder.component.html',
  styleUrls: ['./widget-placeholder.component.scss']
})
export class WidgetPlaceholderComponent implements OnInit {

  @Input() useGhostContent: boolean;

  constructor() { }

  ngOnInit() {
  }

}

@NgModule({
  declarations: [WidgetPlaceholderComponent],
  imports: [CommonModule],
  exports: [WidgetPlaceholderComponent]
})
export class WidgetPlaceholderModule { }
